import { create } from 'zustand';
import { defaultSYS3060_R01Dto, SYS3060_R01Dto } from 'src/containers/mes/SYS/SYS3060_R01/Dto_SYS3060_R01';
import { ColumnState } from 'ag-grid-community';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { MenuDto } from 'src/dtos/menu/menuDto';

export interface SYS3060_R01Filter {
	autGroupCd: string;
	menuCd: string;
	useYn: string;
}

export interface Store_SYS3060_R01 {

	// 검색 조건 (백엔드로 전송)
	SYS3060_R01Filter: SYS3060_R01Filter;
	SYS3060_R01PastFilter: SYS3060_R01Filter;
	setSYS3060_R01Filter: (filter: Partial<SYS3060_R01Filter>) => void;
	setSYS3060_R01PastFilter: (filter: Partial<SYS3060_R01Filter>) => void;
	
	// 권한 그룹 목록 (좌측)
	SYS3060_R01List: SysCodeDto[];
	setSYS3060_R01List: (list: SysCodeDto[]) => void;
	
	// 선택된 권한 그룹
	selectedSYS3060_R01: string | undefined;
	setSelectedSYS3060_R01: (autGroupCd: string | undefined) => void;
	initSelectedSYS3060_R01: () => void;

	// 메뉴 권한 목록 (우측)
	menuAuthorityList: SYS3060_R01Dto[];
	setMenuAuthorityList: (list: SYS3060_R01Dto[]) => void;
	removeMenuAuthorityItem: (menuCd: string) => void;
	updateMenuAuthorityItem: (valueIndex: number, data: SYS3060_R01Dto) => void;

	// 권한 복사 기능 상태
	selectedSourceSYS3060_R01: string;
	setSelectedSourceSYS3060_R01: (value: string) => void;
	selectedTargetSYS3060_R01: string;
	setSelectedTargetSYS3060_R01: (value: string) => void;

	// 삭제/선택 리스트 관리
	deletedMenuAuthorityList: string[];
	addDeletedMenuAuthorityList: (idList: string[]) => void;
	removeDeletedMenuAuthorityList: (idList?: string[]) => void;

	selectedMenuAuthorityList: string[];
	setSelectedMenuAuthorityList: (idList: string[]) => void;
	addSelectedMenuAuthorityList: (idList: string[]) => void;
	removeSelectedMenuAuthorityList: (idList?: string[]) => void;
	initSelectedMenuAuthorityList: () => void;
	allSelectedMenuAuthorityList: () => void;

	// 컬럼 상태 관리
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	menuAuthorityColumnState: ColumnState[] | null;
	setMenuAuthorityColumnState: (state: ColumnState[] | null) => void;

	originalMenuAuthorityList: SYS3060_R01Dto[];
	setOriginalMenuAuthorityList: (list: SYS3060_R01Dto[]) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;
	setDetailFetchTrigger: (trigger: boolean) => void;

	// 초기화
	initData: () => void;
}

export const defaultSYS3060_R01Filter : SYS3060_R01Filter = {
	autGroupCd: '',
	menuCd: '',
	useYn: '',
}

export const useSYS3060_R01Store = create<Store_SYS3060_R01>((set, get) => ({

	// 검색 조건 (백엔드로 전송)
	SYS3060_R01Filter: defaultSYS3060_R01Filter,
	SYS3060_R01PastFilter: defaultSYS3060_R01Filter,
	setSYS3060_R01Filter: (filter) => set((state) => ({ SYS3060_R01Filter: { ...state.SYS3060_R01Filter, ...filter } })),
	setSYS3060_R01PastFilter: (filter) => set((state) => ({ SYS3060_R01PastFilter: { ...state.SYS3060_R01PastFilter, ...filter } })),

	// 권한 그룹 목록
	SYS3060_R01List: [],
	setSYS3060_R01List: (list) => set({ SYS3060_R01List: list }),

	selectedSYS3060_R01: undefined,
	setSelectedSYS3060_R01: (SYS3060_R01: string | undefined) => set((state) => ({
		...state,
		selectedSYS3060_R01: SYS3060_R01,
		selectedMenuAuthorityList: [],
		deletedMenuAuthorityList: [],
		detailFetchTrigger: true,
	})),
	initSelectedSYS3060_R01: () => set({ selectedSYS3060_R01: undefined, menuAuthorityList: [], detailFetchTrigger: false }),

	// 메뉴 권한 목록
	menuAuthorityList: [],
	setMenuAuthorityList: (list: SYS3060_R01Dto[]) => set((state) => {
		let newList: SYS3060_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultSYS3060_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			menuAuthorityList: newList
		}
	}),
	removeMenuAuthorityItem: (menuCd) => set((state) => {
		const newMenuAuthorityList = [...state.menuAuthorityList].filter((item) => item.menuCd !== menuCd);
		return {
			...state,
			menuAuthorityList: newMenuAuthorityList
		}
	}),
	updateMenuAuthorityItem: (valueIndex, data) => set((state) => {
		const _menuAuthorityList = state.menuAuthorityList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			menuAuthorityList: _menuAuthorityList
		}
	}),

	

	// 권한 복사 기능 상태
	selectedSourceSYS3060_R01: '',
	setSelectedSourceSYS3060_R01: (value) => set({ selectedSourceSYS3060_R01: value }),
	selectedTargetSYS3060_R01: '',
	setSelectedTargetSYS3060_R01: (value) => set({ selectedTargetSYS3060_R01: value }),

	// 삭제/선택 리스트
	deletedMenuAuthorityList: [],
	addDeletedMenuAuthorityList: (idList: string[]) => set((state) => {
		const _deletedMenuAuthorityList = [...state.deletedMenuAuthorityList];

		for(const valueIndex of idList) {
			const isInserted = state.menuAuthorityList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.menuAuthorityList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedMenuAuthorityList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedMenuAuthorityList: _deletedMenuAuthorityList
		}
	}),
	removeDeletedMenuAuthorityList: (idList?: string[]) => set((state) => ({
		deletedMenuAuthorityList: [...state.deletedMenuAuthorityList].filter(value => 
			idList ? !idList.includes(value) : false
		)
	})),

	selectedMenuAuthorityList: [],
	setSelectedMenuAuthorityList: (idList: string[]) => set({ selectedMenuAuthorityList: idList }),
	addSelectedMenuAuthorityList: (idList: string[]) => set((state) => {
		const _selectedMenuAuthorityList = [...state.selectedMenuAuthorityList];
		if(idList.length > 0) {
			_selectedMenuAuthorityList.push(...idList);
		}
		return {
			...state,
			selectedMenuAuthorityList: _selectedMenuAuthorityList
		}
	}),
	removeSelectedMenuAuthorityList: (idList?: string[]) => set((state) => ({
		selectedMenuAuthorityList: [...state.selectedMenuAuthorityList].filter(value => 
			idList ? !idList.includes(value) : false
		)
	})),
	initSelectedMenuAuthorityList: () => set({ selectedMenuAuthorityList: [] }),
	allSelectedMenuAuthorityList: () => set((state) => ({
		selectedMenuAuthorityList: state.menuAuthorityList.map(item => item.valueIndex.toString())
	})),

	// 컬럼 상태
	columnState: null,
	setColumnState: (state) => set({ columnState: state }),
	menuAuthorityColumnState: null,
	setMenuAuthorityColumnState: (state) => set({ menuAuthorityColumnState: state }),

	originalMenuAuthorityList: [],
	setOriginalMenuAuthorityList: (list) => set((state) => {
		let newList: SYS3060_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			newList.push({ 
				...defaultSYS3060_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMenuAuthorityList: newList
		}
	}),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	// 초기화
	initData: () => set({
		SYS3060_R01Filter: defaultSYS3060_R01Filter,
		SYS3060_R01PastFilter: defaultSYS3060_R01Filter,

		SYS3060_R01List: [],
		selectedSYS3060_R01: undefined,

		selectedSourceSYS3060_R01: '',
		selectedTargetSYS3060_R01: '',

		menuAuthorityList: [],
		deletedMenuAuthorityList: [],
		selectedMenuAuthorityList: [],		

		originalMenuAuthorityList: [],
		columnState: null,
		menuAuthorityColumnState: null,
		allCount: 0,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	}),
}));

export default useSYS3060_R01Store;
